export const HOST = window.location.hostname.startsWith('localhost')? 'http://localhost:62475':''
export const API_BASE =  HOST + '/umbraco/api/search/';
export const PDF_API_REL = 'get_pdfs';
export const FILTERS_API_REL = 'get_filters';